import axios from 'axios';

export { axios } from 'axios';


var API_URL = String
API_URL = process.env.VUE_APP_APIURL+'/v6/core'

export default class ApiService {

    /*  Created By: Rex Benedict M. Angeles
    *   Description: This will set a header(Authorization) on axios
    *   Date: March 16, 2022
    *   Params: token - jwtToken from cognito
    */
    setHeaders (token) {
        axios.defaults.headers = {
            'Authorization' : token,
            'Content-Type': 'application/json'
        }   
    }

    /*  Created By: Rex Benedict M. Angeles
    *   Description: This function will handle GET request.
    *   Date: March 16, 2022
    *   Params: path - api path/function endpoint, query - additional parameters.
    */
    get (path,query) {
        return axios.get(API_URL + path, query)
    }

    /*  Created By: Rex Benedict M. Angeles
    *   Description: This function will handle POST request.
    *   Date: March 16, 2022
    *   Params: path - api path/function endpoint, query - additional parameters.
    */
    post (path,query) {
        return axios.post(API_URL + path,  query)
    }

}